import firebase from 'firebase'
import { config } from "./index"

export const app = firebase.initializeApp( config.firebase.credentials );

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const firebaseAuth = firebase.auth();


// WEBPACK FOOTER //
// ./src/config/constants.js